import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { RootState } from '@Redux/detail/store';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { AirPlane, Time } from '@components/Common/Icons';
import dayjs from 'dayjs'
import { getIconImageURL } from '@utils/utils';
// search, detail, print 統一type
import { I_DirectionList } from '@Redux/search/interfaces';
import { I_FlightList } from '@Redux/search/interfaces';

interface I_Props {
    direction: I_DirectionList | undefined;
}

const DirectionList: React.FC<I_Props> = ({ direction }) => {
    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const { Id, Name, FlightList } = direction!;
    const [transferTime, setTransferTime] = useState<string[]>([])
    const isPrint = curPage === 'print';
    const isPC = useMediaQuery({ query: '(min-width: 980px)' });

    useEffect(() => {
        if(direction) {
            const flightListComplete = FlightList.map((item) => item)
            const transferTimeArray = []
            for(let i = 0; i < flightListComplete.length - 1; i++) {
                const currentArrival = dayjs(flightListComplete[i]?.ArriveDate+flightListComplete[i]?.ArriveTime)
                const nextDeparture = dayjs(flightListComplete[i+1]?.DepartureDate+flightListComplete[i+1]?.DepartTime)
                const hour = Math.floor(dayjs.duration(nextDeparture.diff(currentArrival)).asHours())
                const minute = dayjs.duration(nextDeparture.diff(currentArrival)).get('minutes')
                const transferTime = `${hour > 0 ? hour+'h' : ''}${minute > 0 ? minute+'m' : ''}`
                transferTimeArray.push(transferTime)
            }
            setTransferTime([...transferTimeArray])
        }
    }, [direction])

    function shorten(date:string) {
        const dateArray = date?.split("/");
        return dateArray?.slice(1).join("/") || '';
    }
    
    function getFlightDirection(flightDirection: string) {
        switch(flightDirection) {
            case "1":
                return "去程"
            case "9":
                return "回程"
            case "O":
                return "中段航班"
        }
    }    

    return (
        <div className={cN(styles['flights__sub'], [isPrint ? 'sub' : ''])}>
            <div className={styles.head}>
                <AirPlane/>
                {direction && <>
                    <span>
                        {getFlightDirection(Id)}
                    </span>
                    {Id !== "O" && 
                    FlightList.length > 0 && 
                    <div className={cN(styles['cities'])}>{`${FlightList[0].DepartureCityName} — ${FlightList[FlightList.length - 1].ArriveCityName}`}</div>}
                </>}
            </div>
            <div className={styles.content}>{FlightList.map((item, index)=>{
                const {
                    Airline,
                    ArriveAirport,
                    ArriveAirportID,
                    ArriveDate,
                    ArriveTime,
                    DepartTime,
                    DepartureAirport,
                    DepartureAirportID,
                    DepartureDate,
                    FlightNo,
                    FlightTime,                    
                } = item
                const hour = parseInt(FlightTime.split(":")[0])
                const minute = parseInt(FlightTime.split(":")[1])
                const airlineCode = FlightNo.slice(0,2)
                
                return (
                    <div className={cN(styles['flight-segment'], Name.includes("中段") && styles['divider'])}  key={`flightSegment-${index+1}`}>
                        <div className={cN(styles['flight-number'], FlightList?.length > 1 ? styles['multiple'] : styles['single'])}>
                            <span>{FlightList.length > 1 && `航段${index+1}`}</span>
                        </div>
                        
                        <div className={cN(styles['flight-infoBlock'])}>
                            <ul className={cN(styles['flight-detail'])}>
                                <li className={cN(styles['locate'], styles['depart'])}>
                                    <div className={cN(styles['dateTime'], styles['coordinate'], isPrint ? styles['printPage']: '')}>
                                        <span>{isPC ? DepartureDate : shorten(DepartureDate)}</span>
                                        <span className={cN(styles['time'])}>{DepartTime}</span>
                                    </div>
                                    <div className={cN(styles['airport'])}>
                                        <span>{DepartureAirportID}</span>
                                        <span>{DepartureAirport}</span>
                                    </div>
                                </li>
                                <li className={cN(styles['flight-time'])}>
                                    <div className={cN(styles['duration'], isPrint ? styles['printPage']: '')}>
                                        <Time/>
                                        <div>
                                            {hour > 0 && `${hour}h`}
                                            {`${minute}m`}
                                        </div>
                                    </div>
                                    <div className={cN(styles['airline-name'])}>
                                        <div className={cN(styles['logo'])}>
                                            <object type="image/png" data={getIconImageURL(airlineCode)}>
                                                <img src={getIconImageURL()} alt="default logo" />
                                            </object>   
                                        </div>
                                        <span>{Airline}</span>
                                        <span>{FlightNo}</span>
                                    </div>
                                </li>
                                <li className={cN(styles['locate'], styles['arrive'])}>
                                    <div className={cN(styles['dateTime'], styles['coordinate'], isPrint ? styles['printPage']: '')}>
                                        <span>{isPC ? ArriveDate : shorten(ArriveDate)}</span>
                                        <span className={cN(styles['time'])}>{ArriveTime}</span>
                                    </div>
                                    <div className={cN(styles['airport'])}>
                                        <span>{ArriveAirportID}</span>
                                        <span>{ArriveAirport}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {(!Name.includes("中段") && !!transferTime[index] === true) && <div className={cN(styles['hintInfo'], styles['transfer-time'])}>
                            轉機 <Time/> {transferTime[index]}
                        </div>}

                        {ArriveDate !== DepartureDate && <div className={cN(styles['hintInfo'], styles['arrive-date'])}>
                            <Time fill="#f03742"/>抵達日期 {dayjs(ArriveDate).format('YYYY/MM/DD')}
                        </div>}
                    </div>
                )
            })}</div>
        </div>
    );
};

export default DirectionList;
